import {
  Companion_getInstancexfdqyjk2ykmw as Companion_getInstance,
  FundsRequesthksopls9wk01 as FundsRequest,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  AccessInfoj60d6hx1qs8r as AccessInfo,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
} from './supportModels.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(FundsRequest_project_getInstance());
}
function prepareFundsRequestFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [FundsRequest__id_getInstance(), FundsRequest_project_getInstance(), FundsRequest_access_getInstance(), FundsRequest_amount_getInstance(), FundsRequest_summary_getInstance(), FundsRequest_pendingDeposits_getInstance(), FundsRequest_deposits_getInstance(), FundsRequest_funded_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function FundsRequest_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function FundsRequest_project$_get_name_$ref_bd2n48() {
  return (p0) => p0.k20();
}
function FundsRequest_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FundsRequest_project$_get_serializer_$ref_8ck9m7() {
  return (p0) => p0.j2j();
}
function FundsRequest_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function FundsRequest_project$_get_annotations_$ref_97av9v() {
  return (p0) => p0.bz();
}
var FundsRequest_projectClass;
function FundsRequest_project() {
  if (FundsRequest_projectClass === VOID) {
    class $ {
      constructor() {
        FundsRequest_project_instance = this;
        var tmp = this;
        tmp.b61_1 = lazy(FundsRequest_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c61_1 = lazy(FundsRequest_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d61_1 = lazy(FundsRequest_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.b61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FundsRequest_project$_get_name_$ref_bd2n48(), null);
        return tmp0.f2();
      }
      e61(receiver) {
        return receiver.g61_1;
      }
      m2j(receiver) {
        return this.e61(receiver instanceof FundsRequest() ? receiver : THROW_CCE());
      }
      n61(receiver, value) {
        return receiver.o61(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FundsRequest() ? receiver : THROW_CCE();
        return this.n61(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FundsRequest_project$_get_serializer_$ref_8ck9m7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FundsRequest_project$_get_annotations_$ref_97av9v(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FundsRequest_project', VOID, VOID, [SerializableProperty()]);
    FundsRequest_projectClass = $;
  }
  return FundsRequest_projectClass;
}
var FundsRequest_project_instance;
function FundsRequest_project_getInstance() {
  if (FundsRequest_project_instance === VOID)
    new (FundsRequest_project())();
  return FundsRequest_project_instance;
}
function FundsRequest__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function FundsRequest__id$_get_name_$ref_71z03t() {
  return (p0) => p0.k20();
}
function FundsRequest__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FundsRequest__id$_get_serializer_$ref_a9p9hs() {
  return (p0) => p0.j2j();
}
function FundsRequest__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function FundsRequest__id$_get_annotations_$ref_i4lvw4() {
  return (p0) => p0.bz();
}
var FundsRequest__idClass;
function FundsRequest__id() {
  if (FundsRequest__idClass === VOID) {
    class $ {
      constructor() {
        FundsRequest__id_instance = this;
        var tmp = this;
        tmp.p61_1 = lazy(FundsRequest__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q61_1 = lazy(FundsRequest__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r61_1 = lazy(FundsRequest__id$annotations$delegate$lambda);
        this.s61_1 = Companion_getInstance_0().m2p();
        this.t61_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.p61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FundsRequest__id$_get_name_$ref_71z03t(), null);
        return tmp0.f2();
      }
      e61(receiver) {
        return receiver.f61_1;
      }
      m2j(receiver) {
        return this.e61(receiver instanceof FundsRequest() ? receiver : THROW_CCE());
      }
      n61(receiver, value) {
        return receiver.o61(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FundsRequest() ? receiver : THROW_CCE();
        return this.n61(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FundsRequest__id$_get_serializer_$ref_a9p9hs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FundsRequest__id$_get_annotations_$ref_i4lvw4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FundsRequest__id', VOID, VOID, [SerializableProperty()]);
    FundsRequest__idClass = $;
  }
  return FundsRequest__idClass;
}
var FundsRequest__id_instance;
function FundsRequest__id_getInstance() {
  if (FundsRequest__id_instance === VOID)
    new (FundsRequest__id())();
  return FundsRequest__id_instance;
}
function FundsRequest_access$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function FundsRequest_access$_get_name_$ref_gm3dv3() {
  return (p0) => p0.k20();
}
function FundsRequest_access$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FundsRequest_access$_get_serializer_$ref_xcqnu2() {
  return (p0) => p0.j2j();
}
function FundsRequest_access$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function FundsRequest_access$_get_annotations_$ref_nfoopm() {
  return (p0) => p0.bz();
}
var FundsRequest_accessClass;
function FundsRequest_access() {
  if (FundsRequest_accessClass === VOID) {
    class $ {
      constructor() {
        FundsRequest_access_instance = this;
        var tmp = this;
        tmp.u61_1 = lazy(FundsRequest_access$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v61_1 = lazy(FundsRequest_access$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w61_1 = lazy(FundsRequest_access$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FundsRequest_access$_get_name_$ref_gm3dv3(), null);
        return tmp0.f2();
      }
      e61(receiver) {
        return receiver.h61_1;
      }
      m2j(receiver) {
        return this.e61(receiver instanceof FundsRequest() ? receiver : THROW_CCE());
      }
      x61(receiver, value) {
        return receiver.o61(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FundsRequest() ? receiver : THROW_CCE();
        return this.x61(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FundsRequest_access$_get_serializer_$ref_xcqnu2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FundsRequest_access$_get_annotations_$ref_nfoopm(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FundsRequest_access', VOID, VOID, [SerializableProperty()]);
    FundsRequest_accessClass = $;
  }
  return FundsRequest_accessClass;
}
var FundsRequest_access_instance;
function FundsRequest_access_getInstance() {
  if (FundsRequest_access_instance === VOID)
    new (FundsRequest_access())();
  return FundsRequest_access_instance;
}
function FundsRequest_amount$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function FundsRequest_amount$_get_name_$ref_39vnvh() {
  return (p0) => p0.k20();
}
function FundsRequest_amount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FundsRequest_amount$_get_serializer_$ref_uwlq2y() {
  return (p0) => p0.j2j();
}
function FundsRequest_amount$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function FundsRequest_amount$_get_annotations_$ref_k968lq() {
  return (p0) => p0.bz();
}
var FundsRequest_amountClass;
function FundsRequest_amount() {
  if (FundsRequest_amountClass === VOID) {
    class $ {
      constructor() {
        FundsRequest_amount_instance = this;
        var tmp = this;
        tmp.y61_1 = lazy(FundsRequest_amount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z61_1 = lazy(FundsRequest_amount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a62_1 = lazy(FundsRequest_amount$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.y61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FundsRequest_amount$_get_name_$ref_39vnvh(), null);
        return tmp0.f2();
      }
      b62(receiver) {
        return receiver.i61_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.b62(receiver instanceof FundsRequest() ? receiver : THROW_CCE()));
      }
      c62(receiver, value) {
        return receiver.o61(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FundsRequest() ? receiver : THROW_CCE();
        return this.c62(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z61_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FundsRequest_amount$_get_serializer_$ref_uwlq2y(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FundsRequest_amount$_get_annotations_$ref_k968lq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FundsRequest_amount', VOID, VOID, [SerializableProperty()]);
    FundsRequest_amountClass = $;
  }
  return FundsRequest_amountClass;
}
var FundsRequest_amount_instance;
function FundsRequest_amount_getInstance() {
  if (FundsRequest_amount_instance === VOID)
    new (FundsRequest_amount())();
  return FundsRequest_amount_instance;
}
function FundsRequest_summary$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function FundsRequest_summary$_get_name_$ref_fzykwb() {
  return (p0) => p0.k20();
}
function FundsRequest_summary$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FundsRequest_summary$_get_serializer_$ref_3p4ye4() {
  return (p0) => p0.j2j();
}
function FundsRequest_summary$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function FundsRequest_summary$_get_annotations_$ref_bb9fa8() {
  return (p0) => p0.bz();
}
var FundsRequest_summaryClass;
function FundsRequest_summary() {
  if (FundsRequest_summaryClass === VOID) {
    class $ {
      constructor() {
        FundsRequest_summary_instance = this;
        var tmp = this;
        tmp.d62_1 = lazy(FundsRequest_summary$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e62_1 = lazy(FundsRequest_summary$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f62_1 = lazy(FundsRequest_summary$annotations$delegate$lambda);
        this.g62_1 = '';
        this.h62_1 = '""';
      }
      k20() {
        var tmp0 = this.d62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FundsRequest_summary$_get_name_$ref_fzykwb(), null);
        return tmp0.f2();
      }
      e61(receiver) {
        return receiver.j61_1;
      }
      m2j(receiver) {
        return this.e61(receiver instanceof FundsRequest() ? receiver : THROW_CCE());
      }
      i62(receiver, value) {
        return receiver.o61(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FundsRequest() ? receiver : THROW_CCE();
        return this.i62(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FundsRequest_summary$_get_serializer_$ref_3p4ye4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FundsRequest_summary$_get_annotations_$ref_bb9fa8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FundsRequest_summary', VOID, VOID, [SerializableProperty()]);
    FundsRequest_summaryClass = $;
  }
  return FundsRequest_summaryClass;
}
var FundsRequest_summary_instance;
function FundsRequest_summary_getInstance() {
  if (FundsRequest_summary_instance === VOID)
    new (FundsRequest_summary())();
  return FundsRequest_summary_instance;
}
function FundsRequest_pendingDeposits$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function FundsRequest_pendingDeposits$_get_name_$ref_xc8ixx() {
  return (p0) => p0.k20();
}
function FundsRequest_pendingDeposits$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FundsRequest_pendingDeposits$_get_serializer_$ref_qx7v9e() {
  return (p0) => p0.j2j();
}
function FundsRequest_pendingDeposits$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function FundsRequest_pendingDeposits$_get_annotations_$ref_1nvo3q() {
  return (p0) => p0.bz();
}
var FundsRequest_pendingDepositsClass;
function FundsRequest_pendingDeposits() {
  if (FundsRequest_pendingDepositsClass === VOID) {
    class $ {
      constructor() {
        FundsRequest_pendingDeposits_instance = this;
        var tmp = this;
        tmp.j62_1 = lazy(FundsRequest_pendingDeposits$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k62_1 = lazy(FundsRequest_pendingDeposits$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l62_1 = lazy(FundsRequest_pendingDeposits$annotations$delegate$lambda);
        this.m62_1 = Companion_instance.o62(0);
        this.n62_1 = '0.cents';
      }
      k20() {
        var tmp0 = this.j62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FundsRequest_pendingDeposits$_get_name_$ref_xc8ixx(), null);
        return tmp0.f2();
      }
      b62(receiver) {
        return receiver.k61_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.b62(receiver instanceof FundsRequest() ? receiver : THROW_CCE()));
      }
      c62(receiver, value) {
        return receiver.o61(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FundsRequest() ? receiver : THROW_CCE();
        return this.c62(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FundsRequest_pendingDeposits$_get_serializer_$ref_qx7v9e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FundsRequest_pendingDeposits$_get_annotations_$ref_1nvo3q(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FundsRequest_pendingDeposits', VOID, VOID, [SerializableProperty()]);
    FundsRequest_pendingDepositsClass = $;
  }
  return FundsRequest_pendingDepositsClass;
}
var FundsRequest_pendingDeposits_instance;
function FundsRequest_pendingDeposits_getInstance() {
  if (FundsRequest_pendingDeposits_instance === VOID)
    new (FundsRequest_pendingDeposits())();
  return FundsRequest_pendingDeposits_instance;
}
function FundsRequest_deposits$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function FundsRequest_deposits$_get_name_$ref_nre1ts() {
  return (p0) => p0.k20();
}
function FundsRequest_deposits$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FundsRequest_deposits$_get_serializer_$ref_nkrjs7() {
  return (p0) => p0.j2j();
}
function FundsRequest_deposits$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function FundsRequest_deposits$_get_annotations_$ref_ycthxn() {
  return (p0) => p0.bz();
}
var FundsRequest_depositsClass;
function FundsRequest_deposits() {
  if (FundsRequest_depositsClass === VOID) {
    class $ {
      constructor() {
        FundsRequest_deposits_instance = this;
        var tmp = this;
        tmp.p62_1 = lazy(FundsRequest_deposits$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q62_1 = lazy(FundsRequest_deposits$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r62_1 = lazy(FundsRequest_deposits$annotations$delegate$lambda);
        this.s62_1 = Companion_instance.o62(0);
        this.t62_1 = '0.cents';
      }
      k20() {
        var tmp0 = this.p62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FundsRequest_deposits$_get_name_$ref_nre1ts(), null);
        return tmp0.f2();
      }
      b62(receiver) {
        return receiver.l61_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.b62(receiver instanceof FundsRequest() ? receiver : THROW_CCE()));
      }
      c62(receiver, value) {
        return receiver.o61(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FundsRequest() ? receiver : THROW_CCE();
        return this.c62(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FundsRequest_deposits$_get_serializer_$ref_nkrjs7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FundsRequest_deposits$_get_annotations_$ref_ycthxn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FundsRequest_deposits', VOID, VOID, [SerializableProperty()]);
    FundsRequest_depositsClass = $;
  }
  return FundsRequest_depositsClass;
}
var FundsRequest_deposits_instance;
function FundsRequest_deposits_getInstance() {
  if (FundsRequest_deposits_instance === VOID)
    new (FundsRequest_deposits())();
  return FundsRequest_deposits_instance;
}
function FundsRequest_funded$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function FundsRequest_funded$_get_name_$ref_ih7cfj() {
  return (p0) => p0.k20();
}
function FundsRequest_funded$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function FundsRequest_funded$_get_serializer_$ref_xqkrje() {
  return (p0) => p0.j2j();
}
function FundsRequest_funded$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function FundsRequest_funded$_get_annotations_$ref_zclviy() {
  return (p0) => p0.bz();
}
var FundsRequest_fundedClass;
function FundsRequest_funded() {
  if (FundsRequest_fundedClass === VOID) {
    class $ {
      constructor() {
        FundsRequest_funded_instance = this;
        var tmp = this;
        tmp.u62_1 = lazy(FundsRequest_funded$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v62_1 = lazy(FundsRequest_funded$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w62_1 = lazy(FundsRequest_funded$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, FundsRequest_funded$_get_name_$ref_ih7cfj(), null);
        return tmp0.f2();
      }
      e61(receiver) {
        return receiver.m61_1;
      }
      m2j(receiver) {
        return this.e61(receiver instanceof FundsRequest() ? receiver : THROW_CCE());
      }
      x62(receiver, value) {
        return receiver.o61(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof FundsRequest() ? receiver : THROW_CCE();
        return this.x62(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, FundsRequest_funded$_get_serializer_$ref_xqkrje(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, FundsRequest_funded$_get_annotations_$ref_zclviy(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'FundsRequest_funded', VOID, VOID, [SerializableProperty()]);
    FundsRequest_fundedClass = $;
  }
  return FundsRequest_fundedClass;
}
var FundsRequest_funded_instance;
function FundsRequest_funded_getInstance() {
  if (FundsRequest_funded_instance === VOID)
    new (FundsRequest_funded())();
  return FundsRequest_funded_instance;
}
//region block: exports
export {
  prepareFundsRequestFields as prepareFundsRequestFields1v1yc7vwqutxm,
  get_project as get_project1eezbsfxh4elg,
};
//endregion

//# sourceMappingURL=FundsRequestFields.mjs.map
